
/**
 * @Author: Zewei
 * @Date:   2018-01-19T11:08:36+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-06T19:50:14+08:00
 */

import axios from 'axios';
import { message } from 'antd';
import apiUrl from "./api-url";
// import WrappedComponent from "../layouts/LayoutWrapper";

let thisYear = null;

 // axiso 设置请求统一拦截器 localStorage 有 未过期的合法 token 则登入，没有则返回登录
 // axios.interceptors.request.use(
 //     (config) => {
 //         if (localStorage && localStorage.access_token) {
 //             config.headers.Authorization = `Bearer ${localStorage.access_token}`;
 //         } else if (window.location.pathname !== '/login') {
 //             window.location.href = './login';
 //         }
 //         return config;
 //     },
 //     (err) => {
 //         console.log(err)
 // });

 const _util = {
     // 网络请求 @param Object
     request (param) {
         axios({
             // url: "http://qi-qd.eicp.net:33075" + param.url || '',
             // url: "http://172.27.0.74:9000" + param.url || '',
             // url: "http://localhost:37792" + param.url || '',
             // url: "http://211.152.36.22:8080" + param.url || '',
             url: apiUrl.url + param.url || '',
             method: param.method || 'get',
             responseType: param.type || 'json',
             params: param.params || {},
             headers: {Authorization: sessionStorage.token},
             // auth: localStorage.access_token ? (localStorage.token_type + '' + localStorage.access_token) : '',
             data: param.data || '',
             success (res) {
                 // 请求成功
                 if (res.status === 200) {
                     typeof param.success === 'function' && param.success(res.data, res.statusText);
                 }
             },
             error (err) {
                 typeof param.error === 'function' && param.error(err);
             }
         })
         .then(param.success)
         .catch(err => {
            if (err.toString() === "Error: Request failed with status code 401") {
                // console.log(111);
                // console.log(push);
                // return (<Redirect push to="/employee/monthy-report" />)
                // WrappedComponent.redirect401();
                message.error("未授权操作!!", 4);
                // setTimeout(() => {
                //     window.location = "/login";
                // },2000);
            }else{
                if ("function" === typeof param.error) {
                    param.error(err);
                }
            }
         })
     },
     // 获取url参数
     getUrlParam (name) {
         var reg     = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
         var result  = window.location.search.substr(1).match(reg);
         return result ? decodeURIComponent(result[2]) : null;
     },
     // 全局成功提示
     successTips (msg) {
         /* eslint-disable no-unused-expressions */
         msg ? msg : '操作成功';
         message.success(msg)
     },
     // 全局错误提示
     errorTips (msg) {
         /* eslint-disable no-unused-expressions */
         msg ? msg : '操作失败';
         message.error(msg)
     },
     // 统一登录处理
     doLogin () {
         window.location.href = './login?redirect=' + encodeURIComponent(window.location.href);
     },
     goBack () {
         window.history.back()
     },
     _thisYear() {
         if (!thisYear) {
             thisYear = new Date().getFullYear()
         }
         return thisYear;
     },
 };

 export default _util;



// WEBPACK FOOTER //
// ./src/utils/index.js